import { ICompany } from '@App/app/entities/admin-panel/company.model';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions/user-companies.actions';

export const userCompaniesAdapter = createEntityAdapter<ICompany>();

export type State = EntityState<ICompany>;

const defaultUserCompanies: State = {
  ids: [],
  entities: {},
};

export const initialState: State = userCompaniesAdapter.getInitialState(defaultUserCompanies);

export const userCompaniesReducer = createReducer(
  initialState,
  on(actions.loadUserCompaniesSuccess, (state, { companies: userCompanies }) => {
    return userCompaniesAdapter.setAll(userCompanies, state);
  }),
);
